/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EffectivePeriod } from './EffectivePeriod';
import type { ProductExclusion } from './ProductExclusion';

export type ProductDetails = {
    id: string;
    order: number;
    name: string;
    status: ProductDetails.status;
    imageMetadataId?: string;
    effectivePeriods?: Array<EffectivePeriod>;
    receiptAcceptanceDaysThreshold: number;
    regions?: Array<'AB' | 'BC' | 'MB' | 'NB' | 'NL' | 'NT' | 'NS' | 'NU' | 'ON' | 'TB' | 'PE' | 'QC' | 'SK' | 'YT'>;
    productId: string;
    sponsorCode: string;
    exclusions?: Array<ProductExclusion>;
};

export namespace ProductDetails {

    export enum status {
        DRAFT = 'DRAFT',
        ACTIVE = 'ACTIVE',
        DISABLED = 'DISABLED',
        EXPIRED = 'EXPIRED',
        UPCOMING = 'UPCOMING',
    }


}

